<app-navbar title="Usuários" />

<div class="container m-auto py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  @if (userId() === 'new') {
    <app-card>
      <app-card-header title="Adicionar Usuário" />
      <span class="text-sm">Um e-mail será enviado para usuário finalizar o cadastramento.</span>

      <form [formGroup]="newUserForm" (submit)="submitNewUser()" class="grid grid-cols-2 mt-8 gap-4">
        <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
          <label for="email" class="font-semibold">Email</label>
          <input
            pInputText
            id="email"
            formControlName="email"
            fluid
            autocomplete="off"
            [invalid]="newUserForm.get('email')?.dirty && newUserForm.get('email')?.errors"
            [disabled]="loading()"
          />
          @if (newUserForm.get('email')?.dirty && newUserForm.get('email')!.hasError('required')) {
            <p-message severity="error" variant="simple" size="small">Email é obrigatório</p-message>
          } @else if (newUserForm.get('email')?.dirty && newUserForm.get('email')!.hasError('email')) {
            <p-message severity="error" variant="simple" size="small">Por favor insira um email válido</p-message>
          }
        </div>
        <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
          <label for="role" class="font-semibold">Nível de acesso</label>
          <p-select
            id="role"
            class="w-full"
            [options]="roleOptions"
            formControlName="role"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
          >
            <ng-template let-item #item>
                <div>{{ item.label | role }}</div>
            </ng-template>
            <ng-template let-item #selectedItem>
              <div>{{ item.label | role }}</div>
            </ng-template>
          </p-select>
          @if (newUserForm.get('role')?.dirty && newUserForm.get('role')!.hasError('required')) {
            <p-message severity="error" variant="simple" size="small">Nível de acesso é obrigatório</p-message>
          }
        </div>
        <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
          <label for="new_utm_afiliados_id" class="font-semibold">ID do Afiliado UTM</label>
          <input
            pInputText
            id="new_utm_afiliados_id"
            formControlName="utm_afiliados_id"
            fluid
            autocomplete="off"
            placeholder="Opcional"
            [disabled]="loading()"
          />
        </div>
        <div class="col-span-2 flex items-center justify-end gap-4">
          <p-button
            styleClass="min-w-42"
            fluid
            label="Cancelar"
            variant="outlined"
            severity="secondary"
            (click)="cancel()"
            [loading]="loading()"
          />
          <p-button
            styleClass="min-w-42"
            fluid
            type="submit"
            [loading]="loading()"
          >
            <div class="flex items-center gap-2">
              <i class="fa-solid fa-floppy-disk -mt-0.5"></i>
              <span>Salvar</span>
            </div>
          </p-button>
        </div>
      </form>
    </app-card>
  } @else {
    <app-card>
      @defer (when updateUserId) {
        <app-card-header [title]="updateUserName || updateUserEmail" />

        @if (updateUserStatus === userStatus.PENDING) {
          <p-message severity="error" variant="simple" size="small">O usuário ainda não completou o cadastro.</p-message>
          <p-button
            severity="danger"
            [loading]="loading()"
            (click)="resendInviteEmail(); $event.preventDefault()"
          >
            <i class="fa-solid fa-envelopes-bulk"></i>
            Reenviar e-mail para concluir cadastro
          </p-button>
        }

        <form [formGroup]="updateUserForm" (submit)="submitUpdateUser()" class="grid grid-cols-6 mt-8 gap-4">
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-2">
            <label for="name" class="font-semibold">Nome</label>
            <input
              pInputText
              id="name"
              formControlName="name"
              fluid
              autocomplete="off"
              [invalid]="updateUserForm.get('name')?.dirty && updateUserForm.get('name')?.errors"
              [disabled]="loading()"
            />
            @if (updateUserForm.get('name')?.dirty && updateUserForm.get('name')!.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Nome é obrigatório</p-message>
            }
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-2">
            <label for="email" class="font-semibold">Email</label>
            <input
              pInputText
              id="email"
              formControlName="email"
              fluid
              autocomplete="off"
              [invalid]="updateUserForm.get('email')?.dirty && updateUserForm.get('email')?.errors"
              [disabled]="loading()"
            />
            @if (updateUserForm.get('email')?.dirty && updateUserForm.get('email')!.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Email é obrigatório</p-message>
            } @else if (updateUserForm.get('email')?.dirty && updateUserForm.get('email')!.hasError('email')) {
              <p-message severity="error" variant="simple" size="small">Por favor insira um email válido</p-message>
            }
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-2">
            <label for="role" class="font-semibold">Nível de acesso</label>
            <p-select
              id="role"
              class="w-full"
              [options]="roleOptions"
              formControlName="role"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            >
              <ng-template let-item #item>
                  <div>{{ item.label | role }}</div>
              </ng-template>
              <ng-template let-item #selectedItem>
                <div>{{ item.label | role }}</div>
              </ng-template>
            </p-select>
            @if (updateUserForm.get('role')?.dirty && updateUserForm.get('role')!.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Nível de acesso é obrigatório</p-message>
            }
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-3">
            <label for="phone" class="font-semibold">Telefone</label>
            <p-inputmask
              id="phone"
              formControlName="phone"
              fluid
              autocomplete="off"
              placeholder="(55) 55555-5555"
              mask="(99) 99999-9999"
              [invalid]="updateUserForm.get('phone')?.dirty && updateUserForm.get('phone')?.errors"
              [disabled]="loading()"
            />
            @if (updateUserForm.get('phone')?.dirty && updateUserForm.get('phone')!.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Telefone é obrigatório</p-message>
            }
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-3">
            <label for="document" class="font-semibold">CPF</label>
            <p-inputmask
              id="document"
              formControlName="document"
              fluid
              autocomplete="off"
              placeholder="000.000.000-00"
              mask="999.999.999-99"
              [invalid]="updateUserForm.get('document')?.dirty && updateUserForm.get('document')?.errors"
              [disabled]="loading()"
            />
            @if (updateUserForm.get('document')?.dirty && updateUserForm.get('document')!.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">CPF é obrigatório</p-message>
            }
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-3">
            <label for="utm_afiliados_id" class="font-semibold">ID do Afiliado UTM</label>
            <input
              pInputText
              id="utm_afiliados_id"
              formControlName="utm_afiliados_id"
              fluid
              autocomplete="off"
              placeholder="Opcional"
              [disabled]="loading()"
            />
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-2">
            <div class="font-semibold">Senha</div>
            <p-button
              class="max-w-80"
              fluid
              severity="secondary"
              [disabled]="updateUserStatus === userStatus.PENDING || loading()"
              [loading]="loading()"
              (click)="sendResetPassword(); $event.preventDefault()"
            >
              <i class="fa-solid fa-key"></i>
              Enviar redefinição de senha
            </p-button>
          </div>
          <div class="flex flex-col justify-start gap-1 col-span-6 md:col-span-2">
            <div class="font-semibold">Status</div>
            <p-selectbutton
              formControlName="status"
              optionLabel="label"
              optionValue="value"
              [options]="[
                {label: 'Ativado', value: 'active'},
                {label: 'Desativado', value: 'inactive'}
              ]"
            />
          </div>
          <div class="col-span-6 flex items-center justify-between gap-4">
              <p-button
                styleClass="sm:min-w-42"
                fluid
                severity="danger"
                [loading]="loading()"
              >
                <div class="flex items-center gap-2">
                  <i class="fa-solid fa-trash-can sm:hidden"></i>
                  <span class="hidden sm:block">Excluir</span>
                </div>
              </p-button>
            <div class="flex items-center justify-end gap-4">
              <p-button
                styleClass="sm:min-w-42"
                fluid
                variant="outlined"
                severity="secondary"
                (click)="cancel()"
                [loading]="loading()"
              >
                <div class="flex items-center gap-2">
                  <i class="fa-solid fa-arrow-left sm:hidden"></i>
                  <span class="hidden sm:block">Cancelar</span>
                </div>
              </p-button>
              @if (updateUserStatus !== userStatus.PENDING) {
                <p-button
                  styleClass="sm:min-w-42"
                  fluid
                  type="submit"
                  [loading]="loading()"
                >
                  <div class="flex items-center gap-2">
                    <i class="fa-solid fa-floppy-disk -mt-0.5"></i>
                    <span class="hidden sm:block">Salvar</span>
                  </div>
                </p-button>
              }
            </div>
          </div>
        </form>

        @if (isMasterAdmin()) {
          <p-divider class="my-8" />

          <app-card-header title="Histórico de atividades" />

          <app-table-activity-logs
            [user_id]="userId()"
          />
        }
      } @loading {
        Loading
      }
    </app-card>
  }
</div>
